<header class="header">

  <app-collapse-navbar></app-collapse-navbar>

</header>

<main role="main" class="container mt-5">
  <app-main-view></app-main-view>
</main>

<footer class="mt-7 px-3 py-5 text-center text-muted">
  <p>
    Profil von Gerd Gruber
  </p>
  <p>
    <a id="to_the_top" class="text-white" i18n>Zum Anfang</a>
  </p>
</footer>
